import { buildModelManager } from "../builder.js";
const DefaultManosFeeLedgerSelection = {
  __typename: true,
  id: true,
  amount: true,
  applicationFeeId: true,
  chargeId: true,
  connectedAccountId: true,
  createdAt: true,
  currency: true,
  eventType: true,
  feeCreatedAt: true,
  originatingChargeId: true,
  profileId: true,
  refundedAmount: true,
  updatedAt: true
};
const modelApiIdentifier = "manosFeeLedger";
const pluralModelApiIdentifier = "manosFeeLedgers";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByApplicationFeeId",
    findByField: "applicationFeeId",
    findByVariableName: "applicationFeeId",
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByApplicationFeeId",
    findByField: "applicationFeeId",
    findByVariableName: "applicationFeeId",
    modelApiIdentifier,
    defaultSelection: DefaultManosFeeLedgerSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "manosFeeLedgerGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ManosFeeLedgerManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultManosFeeLedgerSelection,
  operations
);
export {
  DefaultManosFeeLedgerSelection,
  ManosFeeLedgerManager
};
//# sourceMappingURL=ManosFeeLedger.js.map
